// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: '0.0.1',
  TITLE: 'MYDHL BREAKBULK UAT',
  senderEmail: 'NOREPLY_BBXPREALERT@dhl.com',
  senderEmailReports: 'NOREPLY_BBXREPORT@dhl.com',
  apimKey: '48412e19380844f6b141ef20c34c6c70',
  apimHeader: 'ap-bbx-apim-sk-weu-stg',
  AddressUrl: 'https://breakbulk-uat-apim.dhl.com/bbxportal/address/',
  shipmentUrl: 'https://breakbulk-uat-apim.dhl.com/bbxportal/shipment/',
  configUrl: 'https://breakbulk-uat-apim.dhl.com/bbxportal/config/',
  babyprocessingUrl: 'https://breakbulk-uat-apim.dhl.com/bbxportal/baby/babyProcessing/',
  linking: 'https://breakbulk-uat-apim.dhl.com/bbxportal/baby/babyLinking/',
  mawbUrl: 'https://breakbulk-uat-apim.dhl.com/bbxportal/mother/',
  userUrl: 'https://breakbulk-uat-apim.dhl.com/bbxportal/user/',
  logurl: 'https://breakbulk-uat-apim.dhl.com/bbxportal/',
  passUrl: 'https://breakbulk-uat-apim.dhl.com/bbxportal/user/',
  redirectUrl: 'https://breakbulk-uat.dhl.com/shipment-list',
  authUrl: 'https://stg.dhlpass.dhl.com/auth/oidc',
  passClientId: 'bbx',
  clientSecret: 'zktY=zUt*o.Af`&19~ZZ+',
  passhost: 'https://stg.dhlpass.dhl.com/',
  appUrl: 'https://breakbulk-uat.dhl.com',
  VAULT_GLS_API_KEY: 'YRowGybwB0nG3ohbEbkipMFLuc0bus0K',
};
